import { create } from 'zustand';
import type { BootstrapConfig, CommonsPayload, Signature, TrialPlan, TrialResult } from './types';
import { buildSchedule } from './schedule';

interface DriftglassState {
  bootstrap?: BootstrapConfig;
  deviceKey?: string;
  sessionId?: string;
  deviceHashPrefix?: string;
  schedule: TrialPlan[];
  trials: TrialResult[];
  signature?: Signature;
  commons?: CommonsPayload;
  syncMessage: string;
  setBootstrap: (bootstrap: BootstrapConfig) => void;
  prepareRun: (deviceKey: string) => TrialPlan[];
  setSession: (sessionId: string, deviceHashPrefix: string) => void;
  addTrial: (trial: TrialResult) => void;
  setSignature: (signature: Signature) => void;
  setCommons: (commons: CommonsPayload) => void;
  setSyncMessage: (syncMessage: string) => void;
  resetRun: () => void;
}

export const useDriftStore = create<DriftglassState>((set, get) => ({
  schedule: [],
  trials: [],
  syncMessage: 'local-first; not yet synced',
  setBootstrap: (bootstrap) => set({ bootstrap }),
  prepareRun: (deviceKey) => {
    const schedule = buildSchedule(deviceKey);
    set({ deviceKey, schedule, trials: [], signature: undefined, syncMessage: 'run prepared' });
    return schedule;
  },
  setSession: (sessionId, deviceHashPrefix) => set({ sessionId, deviceHashPrefix, syncMessage: 'anonymous session open' }),
  addTrial: (trial) => set({ trials: [...get().trials, trial] }),
  setSignature: (signature) => set({ signature }),
  setCommons: (commons) => set({ commons }),
  setSyncMessage: (syncMessage) => set({ syncMessage }),
  resetRun: () => set({ schedule: [], trials: [], signature: undefined, sessionId: undefined, deviceHashPrefix: undefined })
}));
